import { RA_ADDITIONAL_TYPES } from '../../../../resource_types';
import { v4 as uuidv4 } from 'uuid';

import { FILTER_TYPES } from 'common/constants/filters';

const filterByType = (arr = [], type) =>
  arr.filter(item => item?.type === type);

const appendTypeToFilters = (filters = [], type) =>
  filters.map(filter => ({
    ...filter,
    type
  }));

const flattenGroupsByKey = (groups, key) =>
  groups.reduce((acc, group) => {
    const items = group?.[key] || [];
    return [...acc, ...items];
  }, []);

export const getAdditionalTypesFlatten = additionalTypes => {
  const customFields = filterByType(
    additionalTypes,
    RA_ADDITIONAL_TYPES.CUSTOM_FIELD
  );
  const labelsGroups = filterByType(
    additionalTypes,
    RA_ADDITIONAL_TYPES.LABEL_GROUP
  );
  const flattenLabels = flattenGroupsByKey(labelsGroups, 'labels');
  return [...customFields, ...flattenLabels];
};

const generateLabelsGroup = (labels = []) => ({
  id: uuidv4(),
  title: 'Labels',
  type: RA_ADDITIONAL_TYPES.LABEL_GROUP,
  labels: labels.map(label => ({ ...label, type: RA_ADDITIONAL_TYPES.LABEL }))
});

export const formatAdditionalTypesToFilters = additionalTypes => {
  const additionalCustomFields = filterByType(
    additionalTypes,
    RA_ADDITIONAL_TYPES.CUSTOM_FIELD
  );
  const additionalLabelsGroups = filterByType(
    additionalTypes,
    RA_ADDITIONAL_TYPES.LABEL_GROUP
  );
  const additionalLabels = flattenGroupsByKey(additionalLabelsGroups, 'labels');

  return {
    [FILTER_TYPES.FIELD]: additionalCustomFields,
    [FILTER_TYPES.LABEL]: additionalLabels
  };
};

export const formatSelectedFiltersToAdditionalTypes = selectedFilters => {
  const customFields =
    selectedFilters?.[FILTER_TYPES.FIELDS_DEFINITIONS] ||
    selectedFilters?.[FILTER_TYPES.FIELD] ||
    [];
  const formattedCustomFields = appendTypeToFilters(
    customFields,
    RA_ADDITIONAL_TYPES.CUSTOM_FIELD
  );

  const labels = selectedFilters?.[FILTER_TYPES.LABEL] || [];

  return [
    ...formattedCustomFields,
    labels.length && generateLabelsGroup(labels)
  ].filter(Boolean);
};
